import { render, staticRenderFns } from "./CandidateDocumentsPreview.vue?vue&type=template&id=289b6387&"
import script from "./CandidateDocumentsPreview.vue?vue&type=script&lang=js&"
export * from "./CandidateDocumentsPreview.vue?vue&type=script&lang=js&"
import style0 from "./CandidateDocumentsPreview.vue?vue&type=style&index=0&id=289b6387&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports